/** @format */

import React, { useEffect, useState } from "react";
import { Subject, useGetSubjectsQuery } from "../../app/services/subjectApi";
import { useTranslation } from "react-i18next";
import { Link, Outlet, useOutletContext, useParams } from "react-router-dom";
import { useLocale } from "../../i18n/hooks";
import { Alert } from "react-bootstrap";

type ContextType = { subject: Subject };

const SubjectPage: React.FC = () => {
  const { subject: subjectTitle } = useParams();
  const { t: _ } = useTranslation();
  const [subject, setSubject] = useState<Subject>();
  const locale = useLocale();

  const { data: subjects, isLoading: isLoadingSubjects } =
    useGetSubjectsQuery();

  document.title = `${subjectTitle} - ${_("Educational Resources")} - ${_("WJEC")}`;

  useEffect(() => {
    if (!isLoadingSubjects && subjects) {
      const subjectObject = subjects.subjects.find(
        (subject: Subject) => subject.title[locale] === subjectTitle,
      );

      setSubject(subjectObject);
    }
  }, [isLoadingSubjects, subjects, subjectTitle, locale]);

  return isLoadingSubjects ? (
    <div className="alert alert-info">{_("Loading")}...</div>
  ) : subject ? (
    <div className="SubjectPage">
      {subject && <Outlet context={{ subject } satisfies ContextType} />}
    </div>
  ) : (
    <Alert variant="danger">
      {_("This subject does not exist")}
      <br />
      <Link to="../">{_("Home")}</Link>
    </Alert>
  );
};

export function useSubject() {
  return useOutletContext<ContextType>();
}

export default SubjectPage;
